var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "expedient-economic-data-container" }, [
    _vm.renderGrid
      ? _c(
          "div",
          { staticClass: "grid-container" },
          [
            _vm.totals && _vm.totals.length
              ? _c("LfTotalsComponent", { attrs: { items: _vm.totals } })
              : _vm._e(),
            Object.keys(_vm.listConfiguration).length &&
            _vm.isGridTableComponentList
              ? _c("GridTableComponent", {
                  attrs: {
                    itemsData: _vm.gridItems,
                    contextMenuItems: _vm.contextMenuItemsEconomicData,
                    gridConfiguration: _vm.mainGridConfiguration,
                    listName: _vm.listConfiguration["Alias"],
                    context: _vm.context,
                    toolbarOptions: _vm.toolbarOptions,
                    commandClick: _vm.onCommandClick,
                    excelExportedFileName: _vm.texts.titles.economicsData,
                  },
                  on: {
                    contextMenuBeforeOpen: _vm.onContextMenuBeforeOpen,
                    otherGridButtonClicked: _vm.openForm,
                    openExpedientEconomicDataForm: _vm.openFormOnEditMode,
                    showDialog: _vm.showDialogComponent,
                    gridTableFilter: _vm.onGridTableFilter,
                    contextMenuClicked: _vm.onContextMenuClicked,
                    customToolbarContextMenuClick:
                      _vm.customToolbarContextMenuClick,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "form-container" },
          [
            _c("TabHeaderComponent", {
              attrs: { buttons: _vm.buttons, title: _vm.getTitle },
              on: {
                closeForm: _vm.onCloseForm,
                saveForm: _vm.onSaveForm,
                removeItem: _vm.showDialogComponent,
              },
            }),
            _vm.formSchema
              ? _c("FormGeneratorComponent", {
                  attrs: {
                    showRequiredFieldsAdvice: true,
                    schema: _vm.formSchemaParsed,
                    fieldValues: _vm.formDataParsed,
                    context: _vm.context,
                  },
                  on: {
                    mountedForm: _vm.onMountedForm,
                    "emit-on-blur-event": _vm.fillTextfieldFields,
                    saveFormData: _vm.onChangeFormFieldValue,
                  },
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "form-grid" },
              [
                _vm.showSimpleGrid
                  ? _c("LfGridComponent", {
                      attrs: {
                        gridConfiguration: _vm.gridConfiguration,
                        itemData: _vm.simpleGridItems,
                        toolbarOptions: _vm.toolbarOptionsCustom,
                        selectionOptions: _vm.selectionOptions,
                      },
                      on: { rowsSelected: _vm.onSelectedRecords },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }